import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => {
  const styleObject = {
    fill: 'none',
    stroke: color,
    strokeWidth: 2,
    strokeMiterlimit: 10,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${defaultSize} ${defaultSize}`}
      width={size}
      height={size}
      {...props}
    >
      <path style={styleObject} d="M8.625 3.75v12h12" />
      <path style={styleObject} d="m15.375 20.25 4.5-4.5-4.5-4.5" />
    </svg>
  );
};
